{
  "schemaVersion": 1,
  "id": "sheesham-board-25",
  "version": "1.0",
  "kind": "board",
  "species": "Sheesham",
  "material": "Solid sheesham",
  "nominalDescription": "Solid sheesham 25 mm, planed all round, oiled",
  "edgeDescription": "Solid sheesham, planed, 1 mm arris",
  "thicknessTicks": 250,
  "nominalThicknessTicks": 250,
  "maxWidthTicks": 2000,
  "maxLengthTicks": 24000,
  "grainAxis": "length",
  "finishSpec": "Hard-wax oil, two coats",
  "density": 770,
  "back": {
    "description": "Birch plywood 6 mm, B/BB, stained to match",
    "thicknessTicks": 60,
    "nominalThicknessTicks": 60,
    "sheet": { "lengthTicks": 24400, "widthTicks": 12200 },
    "grainAxis": "length",
    "allowRotation": false
  },
  "notes": "Self-authored board stock: sheesham is commonly sold planed at 25 mm in widths up to 200 mm; wider parts are edge-glued from strips (plan §5). Density from published air-dry values (≈ 770 kg/m³)."
}
